export default "__VITE_ASSET__c5ec41a2__"